// extracted by mini-css-extract-plugin
export var typeform = "index-module--typeform--Y7ysI";